<template>
    <div id="product">
        <div class="page flex-col">
            <div class="block_1 flex-row">
                <div class="block_2 flex-col justify-end">
                    <div class="group_1 flex-row">
                        <div class="block_3 flex-col">
                            <span class="text_1">当前位置：首页&nbsp;&gt;&nbsp;产品中心</span>
                            <span class="text_2">{{typeInfo.parent_name}}</span>
                            <img class="image_1" referrerpolicy="no-referrer" src="../../../assets/client/dx_1.jpg" />
                        </div>

                        <div class="image-text_1 flex-row justify-between">
                            <div class="block_4 flex-col"></div>
                            <span class="text-group_1">{{ id==""? typeInfo.business_name : productInfo.business_name }}</span>
                            <div class="box_1 flex-col"></div>
                        </div>
                        <div class="text-wrapper_6_be">
                            <transition  name="slide">
                                <div class="text-wrapper_1 flex-col"  v-if="telshow">
                                    <span class="text_3">4001-300-137</span>
                                </div>
                            </transition>
                        </div>
                        <div class="box_8_1">
                            <div class="block_5 flex-row" style="cursor:pointer" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                                <div class="image-text_2 flex-col justify-between">
                                    <img class="label_1" referrerpolicy="no-referrer" src="../../../assets/client/icon_lxfs.png" />
                                    <span class="text-group_2">业务咨询</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="group_2 flex-row justify-between" v-if="id==''">
                        <div class="section_1 flex-col">
                            <div v-for="(item, index) in ProductType" @click="clickType(index)" :style="{cursor: 'pointer', marginTop: index==0 ? '1vw':'' }">
                                <div class="text_4" :style="{color: item.id==typeId? 'rgba(0, 90, 214, 1)':'rgba(30, 30, 30, 1)',fontWeight:item.id==typeId?'600':'normal'}" :title="item.business_name">
                                    {{item.business_name.length>9?item.business_name.substring(0,9)+"...":item.business_name}}
                                </div>
                                <div class="group_3 flex-col"></div>
                            </div>
                        </div>
                        <div class="grid_1 flex-row">
                            <div v-for="(item, index) in Product" @click="getProduct(index)" class="pitem" :style="{'marginRight':(index+1)%3 === 0 ? '0':''}">
                                <div class="list-items_1-0 flex-col" >
                                    <img :src="`${FileAddress+item.FilePath.replace(' ', '%20').replace(/\\/g, '/')}`"></img>
                                </div>
                                <div class="list-items_1-3 flex-col">
                                    <span class="text_13-3" :title="item.business_name">{{item.business_name}}</span>
                                    <div class="group_12-3 flex-col"></div>
                                    <div class="group_13-3 flex-row justify-between">
                                        <span class="text_14-3">查看更多</span>
                                        <span class="text_14_1 el-icon-arrow-right" style="font-size: 0.6vw;"></span>
                                    </div>
                                    <div class="group_14-3 flex-col"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="group_15 flex-row" v-if="id==''">
                        <el-pagination ref="mypage" @current-change="handleCurrentChange" :page-size="form.pageSize"
                                       :current-page="form.pageIndex" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
                    </div>

                    <div class="group_2 flex-row justify-between" v-if="id!=''">
                        <div class="section_1 flex-col">
                            <div v-for="(item, index) in ProductType" @click="clickType(index)" :style="{cursor: 'pointer', marginTop: index==0 ? '1vw':'' }">
                                <span class="text_4" :style="{color: item.id==typeId? 'rgba(0, 90, 214, 1)':'rgba(30, 30, 30, 1)',fontWeight:item.id==typeId?'600':'normal'}" :title="item.business_name">
                                    {{item.business_name.length>9?item.business_name.substring(0,9)+"...":item.business_name}}
                                </span>
                                <div class="group_3 flex-col"></div>
                            </div>
                        </div>
                        <div class="grid_1 flex-row">
                            <table style="width:100%">
                                <tr>
                                    <td style="height: 13.55vw; width: 50%; vertical-align:top;">
                                        <el-carousel :interval="5000" arrow="always" style="border: 1px solid rgb(229, 240, 255);">
                                            <el-carousel-item v-for="item in productInfo.FileList" :key="item" >
                                               <div style="width: 100%;height: 100%; text-align: center;">
                                                    <img :src="FileAddress+item.FilePath"  style="height: 100%;"/>
                                               </div>
                                            </el-carousel-item>
                                        </el-carousel>
                                    </td>
                                    <td style="height: 13.55vw; width: 50%; vertical-align: top">
                                        <div class="group_7_2 flex-col">

                                            <div class="text-wrapper_9_2 flex-col">
                                                <span class="text_28_2">产品简介</span>
                                            </div>
                                            <div class="text-wrapper_10_2" v-html="productInfo.business_desc"></div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" style="height: 2.72vw; vertical-align: top ">
                                        <div class="block_11 flex-col justify-end">
                                            <div class="text-wrapper_11 flex-row justify-between">
                                                <span class="text_30_2" :style="{color:tabType=='business_function'?'rgba(0, 90, 214, 1)':'',fontWeight:tabType=='business_function'?'600':''}" @click="clickTab('business_function')">功能特点</span>
                                                <!--<span class="text_31_2" :style="{color:tabType=='business_index'?'rgba(0, 90, 214, 1)':'',fontWeight:tabType=='business_index'?'600':''}" @click="clickTab('business_index')">产品指标</span>
                                                <span class="text_32_2" :style="{color:tabType=='business_field'?'rgba(0, 90, 214, 1)':'',fontWeight:tabType=='business_field'?'600':''}" @click="clickTab('business_field')">应用领域</span>-->
                                            </div>
                                            <div class="block_12 flex-row" :style="{marginLeft:tabType=='business_function'?'0vw':(tabType=='business_index'?'19.24vw':'38.48vw')}">
                                                <div class="box_7 flex-col"></div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" style="vertical-align: top;">
                                        <div style="min-height: 300px" v-html="productInfo[tabType]"></div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="block_6 flex-col">
                    <div class="p_img">
                        <img src="../../../assets/client/banner_2.png" alt="产品中心" title="产品中心">
                    </div>
                    <div class="p_info">
                        <div>
                            <h2 class="text-white p_btitle">产品中心</h2>
                            <h6 class="text-white p_subtitle">SAILHERO&nbsp;ENVIRONMENTAL&nbsp;PROTECTION</h6>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 移动端页面结构 -->
            <div v-if="isMobile && id==''" class="mobile-product-container">
                <!-- Banner图 -->
                <div class="mobile-product-banner">
                    <img 
                        src="../../../assets/client/banner_2.png" 
                        alt="产品中心" 
                        class="mobile-product-banner__image"
                    />
                    <div class="mobile-product-banner__overlay"></div>
                    <div class="mobile-product-banner__content">
                        <h1 class="mobile-product-banner__title">{{ typeInfo.parent_name || '产品中心' }}</h1>
                        <p class="mobile-product-banner__subtitle">PRODUCT CENTER</p>
                    </div>
                </div>

                <!-- 当前位置 -->
                <div class="mobile-product-breadcrumb">
                    <p class="mobile-product-breadcrumb__text">
                        当前位置：首页 > 产品中心 > 
                        <span class="mobile-product-breadcrumb__current">{{ typeInfo.parent_name }}</span>
                    </p>
                </div>

                <!-- 子菜单按钮列表 (2x2排列) -->
                <div class="mobile-product-submenu">
                    <div class="mobile-product-submenu__grid">
                        <button
                            v-for="(item, index) in ProductType"
                            :key="item.id"
                            :class="['mobile-product-submenu__button', { 'mobile-product-submenu__button--active': item.id === typeId }]"
                            @click="handleSubMenuClick(item)"
                        >
                            {{ item.business_name }}
                        </button>
                    </div>
                </div>

                <!-- 产品列表 -->
                <div class="mobile-product-list">
                    <h2 class="mobile-product-list__title">{{ typeInfo.business_name }}</h2>
                    
                    <div v-if="Product.length > 0" class="mobile-product-list__grid">
                        <div
                            v-for="(item, index) in getMobileDisplayProducts()"
                            :key="item.id"
                            class="mobile-product-card"
                            @click="getProduct(index)"
                        >
                            <div class="mobile-product-card__image-wrapper">
                                <img 
                                    :src="`${FileAddress}${item.FilePath.replace(' ', '%20').replace(/\\/g, '/')}`"
                                    :alt="item.business_name"
                                    class="mobile-product-card__image"
                                />
                            </div>
                            <div class="mobile-product-card__content">
                                <h3 class="mobile-product-card__title">{{ item.business_name }}</h3>
                                <div class="mobile-product-card__divider"></div>
                                <div class="mobile-product-card__footer">
                                    <span class="mobile-product-card__more-text">查看更多</span>
                                    <span class="mobile-product-card__more-icon el-icon-arrow-right"></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 空状态 -->
                    <div v-else class="mobile-product-empty">
                        <div class="mobile-product-empty__icon">📦</div>
                        <p class="mobile-product-empty__text">暂无产品数据</p>
                    </div>
                </div>

                <!-- 查看更多按钮 -->
                <div 
                    v-if="hasMoreProducts()" 
                    class="mobile-product-loadmore"
                >
                    <button 
                        class="mobile-product-loadmore__button"
                        @click="loadMoreProducts"
                    >
                        <span>查看更多</span>
                        <span class="mobile-product-loadmore__icon el-icon-arrow-down"></span>
                    </button>
                </div>
            </div>

            <!-- 移动端产品详情页 -->
            <div v-if="isMobile && id!=''" class="mobile-product-detail">
                <!-- 返回导航栏 -->
                <div class="mobile-detail-navbar">
                    <div class="mobile-detail-navbar__back" @click="backToList">
                        <span class="mobile-detail-navbar__back-icon el-icon-arrow-left"></span>
                        <span>返回</span>
                    </div>
                    <h1 class="mobile-detail-navbar__title">{{ productInfo.business_name }}</h1>
                </div>

                <!-- 详情内容 -->
                <div class="mobile-detail-content">
                    <!-- 大图展示区 -->
                    <div class="mobile-detail-image" v-if="productInfo.FileList && productInfo.FileList.length > 0">
                        <div class="mobile-detail-image__main">
                            <img 
                                :src="`${FileAddress}${productInfo.FileList[selectedImageIndex].FilePath}`"
                                :alt="productInfo.business_name"
                                class="mobile-detail-image__main-img"
                            />
                        </div>
                    </div>

                    <!-- 缩略图列表 -->
                    <div class="mobile-detail-thumbnails" v-if="productInfo.FileList && productInfo.FileList.length > 0">
                        <div class="mobile-detail-thumbnails__list">
                            <div
                                v-for="(item, index) in productInfo.FileList"
                                :key="index"
                                :class="['mobile-detail-thumbnails__item', { 'mobile-detail-thumbnails__item--active': selectedImageIndex === index }]"
                                @click="selectImage(index)"
                            >
                                <img 
                                    :src="`${FileAddress}${item.FilePath}`"
                                    :alt="`${productInfo.business_name} ${index + 1}`"
                                    class="mobile-detail-thumbnails__img"
                                />
                            </div>
                        </div>
                    </div>

                    <!-- 功能导航卡片 -->
                    <div class="mobile-detail-nav-cards">
                        <div 
                            class="mobile-detail-nav-cards__item"
                            @click="scrollToSection('descSection')"
                        >
                            <div class="mobile-detail-nav-cards__icon">📋</div>
                            <div class="mobile-detail-nav-cards__text">产品简介</div>
                        </div>
                        <div 
                            class="mobile-detail-nav-cards__item"
                            @click="scrollToSection('functionSection')"
                        >
                            <div class="mobile-detail-nav-cards__icon">⚙️</div>
                            <div class="mobile-detail-nav-cards__text">功能特点</div>
                        </div>
                    </div>

                    <!-- 产品简介详情区 -->
                    <div class="mobile-detail-section" ref="descSection" v-if="productInfo.business_desc">
                        <div class="mobile-detail-section__header">
                            <h3 class="mobile-detail-section__title">产品简介</h3>
                        </div>
                        <div class="mobile-detail-section__content" v-html="productInfo.business_desc"></div>
                    </div>

                    <!-- 功能特点详情区 -->
                    <div class="mobile-detail-section" ref="functionSection" v-if="productInfo.business_function">
                        <div class="mobile-detail-section__header">
                            <h3 class="mobile-detail-section__title">功能特点</h3>
                        </div>
                        <div class="mobile-detail-section__content" v-html="productInfo.business_function"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import "../../../assets/client/product.css";
import "../../../assets/client/product-mobile.css";
export default{
    data(){
        return {
            typePid: "",
            typeId: "",
            id:"",
            ProductType: [],
            Product: [],
            productInfo: { business_name: "", parent_name: "", business_function: "", business_field: "" },
            typeInfo: { business_name: "", parent_name: "", business_function: "", business_field: "" },
            form: {
                treePath: "",
                level: 4,
                businessType: "产品中心",
                pageSize: 6,
                pageIndex: 1,
                pId: "",
                isShowIndex:0
            },
            total: 0,
            FileAddress: process.env.VUE_APP_FileAddress.replace('fileapi/', ''),
            tabType:"business_function",
            telshow:false,
            // 移动端相关数据
            isMobile: false,
            mobileDisplayCount: 6,
            mobileInitialCount: 6,
            // 移动端详情页相关数据
            selectedImageIndex: 0,
        }
    },
    methods:{
        //当前页变化事件
        handleCurrentChange(val) {
            this.form.pageIndex = val;
            this.getData();
        },
        getDataTree() {
            let that = this;
            that.$api.post("/Client/getBusinessDataByPid", { pid: that.typePid },
                function (res) {
                    that.ProductType = [];
                    that.typeInfo = { business_name: "", parent_name: "", business_function: "", business_field: "" };
                    if (res.code === "200") {
                        that.ProductType = res.data;
                        if (that.ProductType.length > 0) {
                            if (that.typeId == "") {
                                that.typeId = that.ProductType[0].id;
                            }
                            that.typeInfo = that.ProductType.filter(item => { return item.id == that.typeId; })[0];
                            that.getData();
                        }
                    }
                },
                function (res) {
                    //that.$message.error("服务器异常，删除出错");
                }
            );
        },
        clickType(index) {
            this.id = "";
            this.typeInfo = this.ProductType[index];
            this.typeId = this.typeInfo.id;
            this.form.pageIndex = 1;
            this.getData();
        },
        getData() {
            let that = this;
            that.Product = [];
            if (that.id) {
                that.productInfo = { business_name: "", parent_name: "", business_function: "", business_field: "" };
                that.selectedImageIndex = 0; // 重置图片索引
                that.$api.post("/Client/getBusinessDataById", {id:that.id},
                    function (res) {
                        if (res.code === "200") {
                            that.productInfo = res.data;
                        }
                    },
                    function (res) {
                        //that.$message.error("服务器异常，删除出错");
                    }
                );
            }
            else if (that.typeId) {
                that.form.pId = that.typeId;
                that.$api.post("/Client/getBusinessData", that.form,
                    function (res) {
                        if (res.code === "200") {
                            that.Product = res.data;
                            that.total = res.count;
                        }
                    },
                    function (res) {
                        //that.$message.error("服务器异常，删除出错");
                    }
                );
            }
        },
        getProduct(index) {
            let that = this;
            let data = that.Product[index];
            that.$router.push('/Client/Business/Product?tpid=' + data.parent_id3 + '&tid=' + data.parent_id + '&id=' + data.id);
        },
        clickTab(t) {
            this.tabType = t;
        },
        handleMouseEnter(){
                let that = this;
                that.telshow = true;
        },
        handleMouseLeave(){
            let that = this;
            that.telshow = false;
        },
        // 移动端相关方法
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
        loadMoreProducts() {
            // 移动端加载更多产品
            this.mobileDisplayCount += this.mobileInitialCount;
        },
        handleSubMenuClick(subMenu) {
            // 处理子菜单点击，更新路由
            this.$router.push(`/Client/Business/Product?tpid=${this.typePid}&tid=${subMenu.id}&id=`);
        },
        getMobileDisplayProducts() {
            // 获取移动端应该显示的产品列表
            return this.Product.slice(0, this.mobileDisplayCount);
        },
        hasMoreProducts() {
            // 判断是否还有更多产品
            return this.mobileDisplayCount < this.Product.length;
        },
        // 移动端详情页相关方法
        backToList() {
            // 返回产品列表页
            this.$router.push(`/Client/Business/Product?tpid=${this.typePid}&tid=${this.typeId}&id=`);
        },
        selectImage(index) {
            // 切换选中的图片
            this.selectedImageIndex = index;
        },
        scrollToSection(sectionRef) {
            // 平滑滚动到指定区域
            const element = this.$refs[sectionRef];
            if (element) {
                element.scrollIntoView({ 
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        },
    },
    mounted(){
        this.$parent.$refs.menu.setActiveIndex("3");
        this.typePid = this.$route.query.tpid;
        this.typeId = this.$route.query.tid;
        this.id = this.$route.query.id;
        this.getDataTree();
        // 移动端检测
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
        
        // 移动端滚动到页面顶部
        if (this.isMobile) {
            this.$nextTick(() => {
                setTimeout(() => {
                    // 滚动到移动端容器的位置
                    const mobileContainer = document.querySelector('.mobile-product-container');
                    if (mobileContainer) {
                        mobileContainer.scrollIntoView({ behavior: 'auto', block: 'start' });
                    } else {
                        // 备选方案：强制滚动到页面顶部
                        window.scrollTo(0, 0);
                        document.documentElement.scrollTop = 0;
                        document.body.scrollTop = 0;
                    }
                }, 200);
            });
        }
    },
    beforeDestroy() {
        // 移除事件监听
        window.removeEventListener('resize', this.checkMobile);
    },
    watch:{
        '$route.query': {
            handler: function (to, from) {
                this.$parent.$refs.menu.setActiveIndex("3");
                this.typePid = this.$route.query.tpid;
                this.typeId = this.$route.query.tid;
                this.id = this.$route.query.id;
                this.getDataTree();
                
                // 移动端滚动到实际可见内容的顶部
                if (this.isMobile) {
                    this.$nextTick(() => {
                        setTimeout(() => {
                            if (this.id) {
                                // 详情页：滚动到移动端详情容器的位置
                                const mobileDetail = document.querySelector('.mobile-product-detail');
                                if (mobileDetail) {
                                    mobileDetail.scrollIntoView({ behavior: 'auto', block: 'start' });
                                } else {
                                    window.scrollTo(0, 0);
                                    document.documentElement.scrollTop = 0;
                                    document.body.scrollTop = 0;
                                }
                            } else {
                                // 列表页：滚动到移动端容器的位置
                                const mobileContainer = document.querySelector('.mobile-product-container');
                                if (mobileContainer) {
                                    mobileContainer.scrollIntoView({ behavior: 'auto', block: 'start' });
                                } else {
                                    window.scrollTo(0, 0);
                                    document.documentElement.scrollTop = 0;
                                    document.body.scrollTop = 0;
                                }
                            }
                        }, 200);
                    });
                }
            },
            immediate: true // 立即触发
        }
    }
}
</script>
<style scoped>
    .slide-enter-active, .slide-leave-active {
        transition: transform 0.5s;
    }

    .slide-enter, .slide-leave-to /* .slide-leave-active for <2.1.8 */ {
        transform: translateX(22.53vw);
    }


    .p_img img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        animation: bannerimg 2s;
    }

    .p_info .p_btitle {
        animation: puBanner 1s;
        color: #FFF;
        font-size: 59px;
        font-weight: 900;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .p_info .p_subtitle {
        animation: puBanner 1s;
        color: #FFF;
        font-size: 1.458333vw;
        font-weight: 400;
        position: relative;
        bottom: 3.125vw;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        letter-spacing: 0.05625vw;
    }

    .p_info {
        width: 100%;
        max-width: 1600px;
        padding: 0 5px;
        position: absolute;
        left: 257px;
        top: 120px;
        letter-spacing: 3px;
        z-index: 9;
    }

    @keyframes puBanner {
        from {
            transform: translateY(200px);
            opacity: 0
        }

        to {
            transform: translateY(0);
            opacity: 1
        }
    }

    @keyframes bannerimg {
        from {
            transform: scale(1.15)
        }

        to {
            transform: scale(1);
        }
    }
</style>
